import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { Link } from 'react-router';

import ModalDecorator from 'hocs/ModalDecorator';

import ModalButton from '../../ModalButton/ModalButton';
import { RadioGroup, Radio } from '../../../Radio';
import '../style.css';

class DeleteMembershipStep2Modal extends Component {
  constructor() {
    super();

    $.noConflict();

    this.state = {
      selectedOption: 0
    };
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#delete-ms-step2-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#delete-ms-step2-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#delete-ms-step2-modal').modal('hide');
  }

  handleChange = (value) => {
    this.setState({ selectedOption: value });
  }

  handleCancel = (event) => {
    event.preventDefault();
    this.close();
  }

  render() {
    return (
      <div
        id="delete-ms-step2-modal"
        className="DeleteMembershipModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="delete-membership-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="mb-4">We&#39;re sad to hear you want to leave...</h5>
              <h6 className="mb-3">Why are you closing your account?</h6>
              <div className="radio-group">
                <RadioGroup
                  name="pause-membership"
                  selectedValue={this.state.selectedOption}
                  onChange={this.handleChange}
                >
                  <Radio value={1} className="radio-item" label="Rype's customer service" />
                  <Radio value={2} className="radio-item" label="Not enough time right now" />
                  <Radio value={3} className="radio-item" label="Too expensive" />
                  <Radio
                    value={4}
                    className="radio-item"
                    label="Website is too confusing to navigate/use"
                  />
                  <Radio value={5} className="radio-item" label="Not the right solution for me" />
                  <Radio value={6} className="radio-item" label="Had issues with teachers" />
                  <Radio value={7} className="radio-item" label="Didn't get around using it" />
                  <Radio
                    value={8}
                    className="radio-item"
                    label="I've completed my program and reach the level of proficiency I want"
                  />
                  <Radio value={9} className="radio-item" label="Other" />
                </RadioGroup>
              </div>
              <div className="mt-4">
                <ModalButton
                  className="btn btn-primary"
                  modalId="delete-ms-step3-modal"
                  disabled={this.state.selectedOption === 0}
                >
                  Next
                </ModalButton>
                <Link to="#" className="d-inline-block btn-link ml-4" onClick={this.handleCancel}>
                  No thanks, I don&#39;t want to cancel
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalDecorator('delete-ms-step2-modal')(DeleteMembershipStep2Modal);



// WEBPACK FOOTER //
// ./src/components/modals/DeleteMembershipModals/Step2/index.js